module.exports = __webpack_public_path__ + "assets/img/sdwan-module8-4.8da1a33c.jpg";